import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

import Paginate from '../Paginate';
import { ProjectCard } from './components';
import Page from '../Page';
import SearchBar from '../SearchBar/SearchBar';
import { removerAcentos } from '../utils/util';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

//Tipos Possiveis para elementos das colunas da Lista
export const TYPE_STRING = 'STRING';
export const TYPE_DATE = 'DATE';
export const TYPE_TIMESTAMP = 'TIMESTAMP';
export const TYPE_MONEY = 'MONEY';
export const TYPE_NUMBER = 'NUMBER';

const fileTypeXls =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

// Função para exportar dados da tabela para XLS
const exportToXLS = (rawData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(rawData);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileTypeXls });
  FileSaver.saveAs(data, fileName + '.xlsx');
};

// Função para exportar dados da tabela para CSV
const exportToCSV = (rawData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(rawData);
  const csvOutput = XLSX.utils.sheet_to_csv(ws);
  FileSaver.saveAs(new Blob([csvOutput], { type: 'application/octet-stream' }), fileName + '.csv');
};

export const ListaResponsiva = props => {
  //-------------------------------REACT HOOKS ---------------------------------------------------//
  const classes = useStyles();
  const [pagina, setPagina] = useState(props.pagina || 0);
  const [registros, setRegistros] = useState(props.data);
  const [rowsPerPage] = useState(props.rowsPerPage);

  useEffect(() => {
    handleSearch(props.vlrinicial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  //------------------------------- FUNCTIONS ----------------------------------------------------//
  //Funcao para mudar a pagina
  const handlePageChange = props => {
    setPagina(props.selected);
  };

  //Funcao para filtrar pelo input do usuario no componente SearchBar
  const handleSearch = busca => {
    //Se o elemento a ser buscado for nulo, retornar todos os dados
    if (!busca) {
      setRegistros(props.data);
      return;
    }

    busca = removerAcentos(busca);
    var tokens = [].concat
      .apply(
        [],
        busca
          .toUpperCase()
          .split('"')
          .map(function(v, i) {
            return i % 2 ? v : v.split(' ');
          })
      )
      .filter(Boolean);

    // eslint-disable-next-line array-callback-return
    let registrosBuscaveis = props.data.filter(registro => {
      let contador = 0;
      let stringAllColunas = removerAcentos(
        Object.values(registro)
          .toString()
          .toUpperCase()
      );

      let j = 0;
      for (j = 0; j < tokens.length; j++) {
        if (stringAllColunas.includes(tokens[j])) {
          contador++;
        }
      }
      if (contador === tokens.length) {
        return registro;
      }
    });

    const uniqueSet = new Set(registrosBuscaveis);
    const novosRegistro = [...uniqueSet];

    setRegistros(novosRegistro);
    setPagina(0);
  };

  //---------------------------------- RENDER ----------------------------------------------------//
  return (
    <Page className={classes.root}>
      {!props.hideSearchBar && (
        <SearchBar
          vlrinicial={props.vlrinicial}
          onSearch={handleSearch}
          exportToXLS={() => exportToXLS(registros, 'resultado')}
          exportToCSV={() => exportToCSV(registros, 'resultado')}
          showPdfExport={props.showPdfExport}
          exportToPDF={() => props.exportToPDF(registros)}
        />
      )}
      <div className={classes.results}>
        {registros.length > 0 ? (
          registros
            .slice(pagina * rowsPerPage, rowsPerPage + pagina * rowsPerPage)
            .map((project, i) => (
              <ProjectCard
                onClick={project.onclick ? project.onclick : null}
                key={`pc-${i}`}
                project={project}
                colunas={props.colunas}
              />
            ))
        ) : (
          <Typography
            className={classes.avisoSemRegistro}
            color="textSecondary"
            gutterBottom
            variant="body1">
            Não há registros a serem exibidos
          </Typography>
        )}
      </div>
      <div className={classes.countRegistrosContainer}>
        {!props.hideCountRegistros && registros.length > 0 && (
          <Typography color="textSecondary" gutterBottom>
            <b>{registros.length}</b> registros
            <br /> Página: <b>{pagina + 1}</b> de {Math.ceil(registros.length / rowsPerPage)}{' '}
          </Typography>
        )}
      </div>
      {!props.hidePaginate && registros.length > 0 && (
        <div className={classes.paginate}>
          <Paginate
            pageCount={registros.length / rowsPerPage}
            onPageChange={handlePageChange}
            forcePage={pagina}
          />
        </div>
      )}
    </Page>
  );
};

//----------------------------------- PROPTYPES --------------------------------------------------//
ListaResponsiva.propTypes = {
  data: PropTypes.array.isRequired,
  colunas: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  pagina: PropTypes.number,
  hidePaginate: PropTypes.bool,
  hideCountRegistros: PropTypes.bool,
  hideSearchBar: PropTypes.bool,
  vlrinicial: PropTypes.string,
  selected: PropTypes.number,
  exportToPDF: PropTypes.func,
  showPdfExport: PropTypes.bool,
};
//------------------------------------------------------------------------------------------------//

//-----------------------------------ESTILIZAÇÃO--------------------------------------------------//
const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(1),
  },
  results: {
    marginTop: theme.spacing(2),
  },
  paginate: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
  },
  countRegistrosContainer: {
    margin: '1rem 0',
    textAlign: 'center',
    fontSize: '1rem',
  },
  avisoSemRegistro: {
    textAlign: 'center',
    margin: '2rem auto',
    fontSize: '1rem',
  },
}));
//------------------------------------------------------------------------------------------------//
